import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { stripIgnoredCharacters } from 'graphql'
import fetch from 'isomorphic-fetch'
import introspection from '../__generated__/fragment-matcher'
import resolvers from './resolvers'

// Contentful rejects queries over 8192 bytes (QUERY_TOO_BIG), so strip whitespace before sending
const printMinified = (ast, originalPrint) =>
  stripIgnoredCharacters(originalPrint(ast))

export const previewClient = new ApolloClient({
  link: createHttpLink({
    uri: `https://graphql.contentful.com/content/v1/spaces/${process.env.GATSBY_CONTENTFUL_SPACE}/environments/${process.env.GATSBY_CONTENTFUL_ENV}`,
    headers: {
      authorization: `Bearer ${process.env.GATSBY_CONTENTFUL_PREVIEW_ACCESS_TOKEN}`,
    },
    fetch,
    print: printMinified,
  }),
  cache: new InMemoryCache({
    possibleTypes: introspection.possibleTypes,
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'none',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'none',
    },
  },
  resolvers,
})

export const client = new ApolloClient({
  link: createHttpLink({
    uri: `https://graphql.contentful.com/content/v1/spaces/${process.env.GATSBY_CONTENTFUL_SPACE}/environments/${process.env.GATSBY_CONTENTFUL_ENV}`,
    headers: {
      authorization: `Bearer ${process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN}`,
    },
    fetch,
    print: printMinified,
  }),
  cache: new InMemoryCache({
    possibleTypes: introspection.possibleTypes,
  }),
  resolvers,
})
